import React from 'react';
import { formatPriceRange } from '@util/insights/topSearchesNov2025';

interface PriceRangeProps {
  low: number;
  high: number;
  median: number;
  showMedianIndicator?: boolean;
}

export const PriceRange: React.FC<PriceRangeProps> = ({
  low,
  high,
  median,
  showMedianIndicator = true,
}) => {
  const diff = high - low;
  const medianPosition = diff > 0 ? ((median - low) / diff) * 100 : 50;

  // If range is tight (< $50), show single value
  if (diff < 50) {
    return (
      <span className="font-medium text-gray-900">
        ${low.toLocaleString()}
      </span>
    );
  }

  return (
    <div className="space-y-1">
      {/* Price range text */}
      <div className="font-medium text-gray-900">
        ${low.toLocaleString()} – ${high.toLocaleString()}
      </div>

      {/* Visual range bar with median indicator */}
      {showMedianIndicator && (
        <div className="relative w-full h-2 bg-gray-200 rounded-full">
          <div
            className="absolute top-1/2 -translate-y-1/2 w-0 h-0 border-l-[4px] border-l-transparent border-r-[4px] border-r-transparent border-t-[6px] border-t-brand-orange"
            style={{ left: `${medianPosition}%`, transform: 'translateX(-50%) translateY(-50%)' }}
            title={`Median: $${median.toLocaleString()}`}
          />
        </div>
      )}
    </div>
  );
};
